import get from "lodash/get";

import { getFile, getMultiName } from "helpers/mappers";

export const ServiceRegister = (item) => ({
  id: get(item, "id") || "",
  info1: get(item, "info1") || "",
  info2: get(item, "info2") || "",
  info3: get(item, "info3") || "",
  info4: get(item, "info4") || "",
  info5: get(item, "info5") || "",
  info6: get(item, "info6") || "",
  info7: get(item, "info7") || "",
  info8: get(item, "info8") || "",
  info9: get(item, "info9") || "",
  info10: get(item, "info10") || "",
  info11: get(item, "info11") || "",
  info12: get(item, "info12") || "",
  okeds5: get(item, "okeds5") || "",
});

export const OpenStats = (item) => ({
  id: get(item, "id") || "",
  name: getMultiName(get(item, "name")) || "",
  register_requirements_count: get(item, "register_requirements_count") || 0,
  file_response: getFile(get(item, "file_response")),
});
